import { ExternalLink } from 'lucide-react'
import classNames from 'classnames'

import Flex from '@/elements/Flex'
import { IS_MOBILE_APP } from '@/constants'
import { MobileAppBridge } from '@/utils/mobileAppActions'
import { colors } from '@/utils/theme'

import './ExternalLinkCard.scss'

interface ExternalLinkCardProps {
  to: string
  children: React.ReactNode
  Icon?: React.ElementType
  imageSrc?: string
  targetBlank?: boolean
  fileName?: string
  textWrap?: boolean
}

function ExternalLinkCard({
  to,
  children,
  Icon,
  imageSrc,
  targetBlank = true,
  fileName,
  textWrap = true
}: ExternalLinkCardProps) {
  const renderIllustration = () => {
    if (imageSrc) {
      return (
        <Flex align='center' justify='center' className='image'>
          <img src={imageSrc} alt='' />
        </Flex>
      )
    }
    if (Icon) {
      return (
        <Flex align='center' justify='center' className='image'>
          <Icon size={18} />
        </Flex>
      )
    }
    return null
  }

  if (IS_MOBILE_APP) {
    return (
      <div
        className='external-link-card'
        onClick={() => MobileAppBridge.externalLink(to)}
      >
        <Flex inline align='center' p={3} gap={2} className='link-content'>
          {renderIllustration()}
          <Flex grow>
            {children}
          </Flex>
          <ExternalLink
            size={20}
            style={{ minWidth: 20, minHeight: 20 }}
            color={colors['black-light-40']}
          />
        </Flex>
      </div>
    )
  }

  return (
    <a
      className={classNames('external-link-card', { 'text-wrap': textWrap })}
      href={to}
      target={targetBlank ? '_blank' : undefined}
      rel='noopener noreferrer'
      download={fileName}
    >
      <Flex inline align='center' p={3} gap={2} className='link-content'>
        {renderIllustration()}
        <Flex grow>
          {children}
        </Flex>
        <ExternalLink
          size={20}
          style={{ minWidth: 20, minHeight: 20 }}
          color={colors['black-light-40']}
        />
      </Flex>
    </a>
  )
}

export default ExternalLinkCard
